import { render, staticRenderFns } from "./CampusDevicesSummit.vue?vue&type=template&id=4a07b4ea&scoped=true&"
import script from "./CampusDevicesSummit.vue?vue&type=script&lang=ts&"
export * from "./CampusDevicesSummit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a07b4ea",
  null
  
)

export default component.exports